import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { useVerifyTrialInviteQuery } from '../api/hooks/useVerifyTrialInviteQuery';

import { ROUTES } from '../../../../../../../constants/routes';

const asNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

export const useTrialInviteGate = () => {
  const history = useHistory();
  const { search } = useLocation();

  const { email, id, verification_code } = useMemo(() => {
    const params = queryString.parse(search);
    return {
      email: asNonEmptyString(params.email),
      id: asNonEmptyString(params.id),
      verification_code: asNonEmptyString(params.verification_code),
    };
  }, [search]);

  const hasRequiredParams = Boolean(email && id && verification_code);

  const { data, isLoading, isError, isSuccess } = useVerifyTrialInviteQuery({
    id: id || '',
    verification_code: verification_code || '',
    enabled: hasRequiredParams,
  });

  const isVerified = isSuccess && data?.valid === true;

  useEffect(() => {
    if (!hasRequiredParams) {
      history.replace(ROUTES.EXPIRED_INVITATION);
      return;
    }

    if (isError || (isSuccess && data?.valid !== true)) {
      history.replace(ROUTES.EXPIRED_INVITATION);
    }
  }, [hasRequiredParams, isError, isSuccess, data, history]);

  return {
    isVerified,
    isVerifying: hasRequiredParams && isLoading,
    inviteEmail: email || '',
    inviteId: id || '',
    inviteVerificationCode: verification_code || '',
  };
};
